import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderState } from '../models/loader-state';

@Injectable({
  providedIn: 'root'
})
export class ApiLoaderService {

  private loaderStateSubject = new BehaviorSubject<LoaderState>({ show: false });
  loaderState = this.loaderStateSubject.asObservable();

  show() {
    this.loaderStateSubject.next({ show: true });
  }

  hide() {
    this.loaderStateSubject.next({ show: false });
  }

  // Number of HTTP requests in flight (all requests, including hideLoader ones).
  // Used by tables to show skeleton rows while data is loading.
  private activeRequests = 0;
  private activeRequestsSubject = new BehaviorSubject<number>(0);
  activeRequests$ = this.activeRequestsSubject.asObservable();

  // Counted so overlapping saves don't close the overlay early
  private blockingRequests = 0;

  blockingStarted() {
    if (++this.blockingRequests === 1) this.show();
  }

  blockingEnded() {
    this.blockingRequests = Math.max(0, this.blockingRequests - 1);
    if (this.blockingRequests === 0) this.hide();
  }

  get pendingRequests(): number {
    return this.activeRequests;
  }

  requestStarted() {
    this.activeRequestsSubject.next(++this.activeRequests);
  }

  requestEnded() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    this.activeRequestsSubject.next(this.activeRequests);
  }
}
